import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const permeability = {
    jpath: ['spectra', 'permeability'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default permeability;
//# sourceMappingURL=permeability.js.map